import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';

import type { NotificationType } from '../types';
import { NotificationIcon } from './NotificationIcon';

interface NotificationEmptyStateProps {
    type: NotificationType;
    /** Popover lists are fixed-height; the drawer's fill their flex parent. */
    className?: string;
}

/** "Nothing here yet" for one tab. Shared by the popover and the drawer. */
export function NotificationEmptyState({ type, className }: NotificationEmptyStateProps) {
    const { t } = useTranslation();

    return (
        <div
            className={cn(
                'flex flex-col items-center justify-center gap-1 px-6 text-center',
                className,
            )}
        >
            <NotificationIcon name="Bell" className="size-6 text-muted-foreground/50" />
            <p className="text-sm text-muted-foreground">
                {type === 'MESSAGE'
                    ? t('notifications.empty.messages', 'No messages yet')
                    : t('notifications.empty.alerts', 'No alerts yet')}
            </p>
        </div>
    );
}
